import React from 'react';
import Header from '../HeaderSection/Header';
import FooterSection from '../FooterSection/Footer';

const LegalPageLayout = ({ children }) => {
    return (
        <div className="inner-pages">
            {/*====== Scroll To Top Area Start ======*/}
            <div id="scrollUp" title="Scroll To Top">
                <i className="fas fa-arrow-up" />
            </div>
            {/*====== Scroll To Top Area End ======*/}
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                {children}
                <FooterSection />
            </div>
        </div>
    );
};

export default LegalPageLayout; 